interface IImpersonateUserIconProps {
  className?: string;
}

/**
 * Novelty disguise — round glasses bridged across a mustache, the universal
 * "I'm someone else now" signal. Monoline, `currentColor`, no fills. Reads
 * cleanly at the home tile's ~40px and at full page scale.
 */
const ImpersonateUserIcon = ({ className }: IImpersonateUserIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* eyebrows */}
    <path d="M8 14 q4 -3 8 0" />
    <path d="M32 14 q4 -3 8 0" />
    {/* round glasses + bridge */}
    <circle cx="13" cy="22" r="6" />
    <circle cx="35" cy="22" r="6" />
    <path d="M19 22 h10" />
    {/* nose hint */}
    <path d="M24 28 v3" />
    {/* mustache */}
    <path d="M16 34 q4 4 8 0 q4 4 8 0" />
  </svg>
);

export default ImpersonateUserIcon;
